import React from "react";
import SvgComponent from "../SvgComponent";

export const AuthModalHeader = ({
  title,
  onClose,
  language,
  titleClassName = "text-F24",
}) => (
  <div
    className={`relative z-[60] flex items-center justify-between ${
      language === "_ar" ? "flex-row-reverse" : ""
    }`}
  >
    <h1 className={`text-white font-bold ${titleClassName}`}>{title}</h1>
    {onClose && (
      <button
        type="button"
        onClick={onClose}
        className="cursor-pointer p-1 shrink-0"
        aria-label="Close"
      >
        <SvgComponent
          name="Cross"
          className="w-3 h-3"
          stroke="white"
          fill="none"
        />
      </button>
    )}
  </div>
);
